/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import InputText from '../../InputText'
import {
  LICENSE_TERMS_LABEL,
  MINIMUM_PRICE_LABEL,
  NUMBER_OF_LICENSES_LABEL,
  REQUIRED_ROYALTY_LABEL,
  USAGE_FEE_LABEL,
  USAGE_LIMIT_LABEL
} from './handlers'
import { useResponsive } from '@/hooks/useResponsive'
import { Flex } from '@chakra-ui/react'

const LicensingFieldsForHookForm = ({
  errors,
  licenseTermLabel = LICENSE_TERMS_LABEL,
  minimumPriceLabel = MINIMUM_PRICE_LABEL,
  numberOfLicensesLabel = NUMBER_OF_LICENSES_LABEL,
  register = () => {},
  requiredRoyaltyLabel = REQUIRED_ROYALTY_LABEL,
  usageFeeLabel = USAGE_FEE_LABEL,
  usageLimitLabel = USAGE_LIMIT_LABEL,
  numberLicensesKey = 'numberOfLicenses'
}) => {
  const { flexDirection } = useResponsive()

  return (
    <section>
      <Flex
        flexDirection={flexDirection}
        className="gap-4"
      >
        <InputText
          errorMessage={errors?.minimumPrice?.message}
          label={minimumPriceLabel}
          { ...register('minimumPrice') }
        />
        <InputText
          errorMessage={errors?.requiredRoyalty?.message}
          label={requiredRoyaltyLabel}
          rightAddonContent="%"
          { ...register('requiredRoyalty') }
        />
        <InputText
          errorMessage={errors?.[numberLicensesKey]?.message}
          label={numberOfLicensesLabel}
          { ...register(numberLicensesKey) }
        />
      </Flex>
      <Flex
        flexDirection={flexDirection}
        className="gap-4"
      >
        <InputText
          errorMessage={errors?.usageLimit?.message}
          label={usageLimitLabel}
          { ...register('usageLimit') }
        />
        <InputText
          errorMessage={errors?.usageFee?.message}
          label={usageFeeLabel}
          { ...register('usageFee') }
        />
        <InputText
          errorMessage={errors?.licenseTerm?.message}
          label={licenseTermLabel}
          { ...register('licenseTerm') }
        />
      </Flex>
    </section>
  )
}

export default LicensingFieldsForHookForm
